// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__tpej7","grid":"Footer_grid__Z4Nyq","list":"Footer_list__lzQY0","listMb":"Footer_listMb__3NXbv"};